// ProfileHeader.tsx (Enhanced with Contact Info)
import React from "react";
import { Professional } from "./types";

interface ProfileHeaderProps {
  professional: Professional;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ professional }) => {
  // Handle call button click
  const handleCallClick = () => {
    if (professional.telephone) {
      window.location.href = `tel:${professional.telephone}`;
    } else {
      alert("Número de teléfono no disponible");
    }
  };

  // Handle email button click
  const handleEmailClick = () => {
    if (professional.email) {
      window.location.href = `mailto:${professional.email}`;
    } else {
      alert("Dirección de email no disponible");
    }
  };

  return (
    <div className="profile-header">
      <div className="profile-image-container">
        <img
          src={professional.imageUrl || "/user_placeholder.svg"}
          alt={professional.name}
          className="profile-img"
        />
        {/* Online status indicator */}
        <div className="online-indicator"></div>
      </div>
      <div className="profile-info">
        <div className="profile-main">
          <h1>{professional.name}</h1>
          {/* Render specialties as an array */}
          {professional.specialty && professional.specialty.length > 0 ? (
            <div className="specialties-container">
              {professional.specialty.map((specialty, index) => (
                <h3 key={index} className="specialty-tag">
                  {specialty}
                  {index < professional.specialty.length - 1}
                </h3>
              ))}
            </div>
          ) : (
            <h3>Sin especialidad</h3>
          )}
        </div>
        <p>{professional.description}</p>

        {/* Mobile-only contact buttons */}
        <div className="mobile-contact-buttons">
          <button
            className="btn btn--secondary btn--small"
            onClick={handleCallClick}
            disabled={!professional.telephone}
            title={
              professional.telephone
                ? `Llamar a ${professional.telephone}`
                : "Sin teléfono"
            }
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328z" />
            </svg>
            Llamar
          </button>
          <button
            className="btn btn--primary btn--small"
            onClick={handleEmailClick}
            disabled={!professional.email}
            title={
              professional.email
                ? `Enviar email a ${professional.email}`
                : "Sin email"
            }
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z" />
            </svg>
            Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
